import Sports from "../components/pages/Sports";

export default Sports;
